// Per-session builder stylesheets — the session payload ships a `styles[]`
// array of URLs that must be loaded as <link> tags before the themed UI paints.

const BUILDER_STYLE_ID_PREFIX = 'builder_style_'

function removeExistingBuilderStyles() {
  if (typeof document === 'undefined') {
    return
  }
  const existing = document.querySelectorAll(`link[id^="${BUILDER_STYLE_ID_PREFIX}"]`)
  existing.forEach(el => el.parentElement?.removeChild(el))
}

export interface ApplyBuilderStylesResult {
  loaded: number
  errored: number
}

export function applyBuilderStyles(urls: string[] | undefined | null): Promise<ApplyBuilderStylesResult> {
  return new Promise(resolve => {
    if (typeof document === 'undefined') {
      resolve({ loaded: 0, errored: 0 })
      return
    }

    removeExistingBuilderStyles()

    const list = (urls || []).filter(Boolean)
    if (!list.length) {
      resolve({ loaded: 0, errored: 0 })
      return
    }

    let loaded = 0
    let errored = 0
    const finish = () => {
      if (loaded + errored === list.length) {
        resolve({ loaded, errored })
      }
    }

    list.forEach((url, idx) => {
      const link = document.createElement('link')
      link.id = `${BUILDER_STYLE_ID_PREFIX}${idx}`
      link.rel = 'stylesheet'
      link.href = url
      link.onload = () => {
        loaded += 1
        finish()
      }
      link.onerror = () => {
        errored += 1
        finish()
      }
      document.head.appendChild(link)
    })
  })
}
